var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.53 12.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.58,18.91a9,9,0,0,0,9.06-9.07c0-.13,0-.27,0-.41a6.4,6.4,0,0,0,1.59-1.65,5.91,5.91,0,0,1-1.83.5,3.15,3.15,0,0,0,1.4-1.76,6.34,6.34,0,0,1-2,.78,3.18,3.18,0,0,0-5.51,2.18,3.38,3.38,0,0,0,.08.72A9,9,0,0,1,5.77,6.87a3.22,3.22,0,0,0-.43,1.6,3.18,3.18,0,0,0,1.42,2.66,3.16,3.16,0,0,1-1.44-.4v0a3.19,3.19,0,0,0,2.56,3.12A2.94,2.94,0,0,1,7,14a4,4,0,0,1-.6-.05,3.2,3.2,0,0,0,3,2.21,6.43,6.43,0,0,1-4,1.36,6.34,6.34,0,0,1-.76,0,9.07,9.07,0,0,0,4.89,1.43",
    transform: "translate(-4.69 -6.29)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcT);
export default __webpack_public_path__ + "static/media/ic_t.2ee71483e8e7d04484d3ccbf18c8c3d4.svg";
export { ForwardRef as ReactComponent };